import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { AuthErrorInstance } from './classes/AuthErrorInstance';
import msalInstance from './msalInstance';

const initAccount = () => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
 
    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
            AuthErrorInstance.getInstance().setIsRedirected(true);
        }
    });
};

export default initAccount;
